import { RootState } from '..';
import { getActiveComponentDesignGuid } from './getActiveComponentDesignSelector';
import { getAnalysisSettings } from './settingsDatabaseSelectors';

// Not memoized since we're passing all of state to getAnalysisSettings so it wouldn't do any good.
export const getAnalysisSettingsForActiveComponentDesign = (state: RootState) => {
  const activeComponentDesignGuid = getActiveComponentDesignGuid(state);
  return activeComponentDesignGuid != null ? getAnalysisSettings(state, activeComponentDesignGuid) : null;
};
